/**
 * Created by nguyendx on 2017/09/18.
 */
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response, ResponseContentType, URLSearchParams, } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import * as FileSaver from 'file-saver';

// import { from } from "rxjs";

@Injectable()
export class ApiEvsService {
  private header: Headers;
  private endPoint: string;
  private endPointAdd: string;

  constructor(private http: Http, private router: Router) {
    let contentHeaders = new Headers();
    this.header = contentHeaders;
  }

  public setHeader(key: string, value: string): ApiEvsService {
    this.header.set(key, value);
    return this;
  }

  public setEndPoint(s: string) {
    this.endPoint = s;
  }
  getFile2(url: string, options?: any): Observable<any> {
    // let params = new URLSearchParams();
    // if (typeof options === "object") {
    //   for (var i in options) {
    //     params.set(i, options[i]);
    //   }
    // }
    // this.header.set('Content-Type', "application/json");
    // if (localStorage.getItem("Access-Token")) {
    //   this.header.set("authorization", localStorage.getItem("Access-Token"));
    // }

    const type = 'application/vnd.ms-excel';
    const options2 = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: new Headers({ 'Accept': type, 'authorization': localStorage.getItem("Access-Token"), 'Accept-Language': localStorage.getItem('lang') || 'vi' })
    });
    return this.http
      .get(url, options2)
      .map((res: any) => {
        if (res instanceof Response) {
          return res.blob();
        }
        return res;
      })
      .catch((error: any) => {
        console.log('errrorrrrrrrrr', error)
        throw this.checkErr(error);
      });
  }

  login(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    this.header.set('Authorization', '');
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');

    return this.http
      .post(environment.api_evs + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  linkAccount(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    return this.http
      .put(environment.api_evs + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  getExcel(url: string, options?: any): Observable<any> {
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .get(environment.api_evs + url, { headers: this.header, search: params })
      .map((res: any) => {
        return res;
      });
  }

  getExcel2(url: string, options?: any): Observable<any> {
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .get(environment.api_evs + url, { headers: this.header, search: params, responseType: 3 })
      .map((res: any) => {
        return res;
      });
  }

  get(url: string, options?: any): Observable<any> {
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .get(environment.api_evs + url, { headers: this.header, search: params })
      .map((res: any) => {
        // console.log("ewsss", res);
        return this.check(res);
      })
      .catch((error: any) => {
        // console.log("errrorrrrrrrrr", error)
        throw this.checkErr(error);
      });
  }

  getFile(url: string, options?: any): Observable<any> {
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');

    const type = 'application/vnd.ms-excel';
    const options2 = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: new Headers({ 'Accept': type, 'authorization': localStorage.getItem('Access-Token'), 'Accept-Language': localStorage.getItem('lang') || 'vi' })
    });
    return this.http
      .get(environment.api_evs + url, options2)
      .map((res: any) => {
        if (res instanceof Response) {
          return res.blob();
        }
        return res;
      })
      .catch((error: any) => {
        console.log('errrorrrrrrrrr', error)
        throw this.checkErr(error);
      });
  }

  get_qr_aps(url: string, options?: any): Observable<any> {
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .get(environment.qrcode_url + url, {
        headers: this.header,
        search: params,
      })
      .map((res: any) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  get_qr_core_aps(url: string, options?: any): Observable<any> {
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .get(environment.qrcode_url_aps + url, {
        headers: this.header,
        search: params,
      })
      .map((res: any) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }
  /**Tuanba: 26-2-2024: Viết GET POST mới lấy token mới **/
  get_qr_core_aps_new_token(url: string, options?: any): Observable<any> {
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token-Reset'));
    }
    return this.http
      .get(environment.qrcode_url_aps + url, {
        headers: this.header,
        search: params,
      })
      .map((res: any) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }
  post_new_token(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token-Reset')) {
      this.header.set('authorization', localStorage.getItem('Access-Token-Reset'));
    }
    return this.http
      .post(environment.api_evs + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  getNoToken(url: string, options?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    return this.http
      .get(environment.api_evs + url, { headers: this.header, search: params })
      .map((res: any) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  getFullUrl(url_api: string, options?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    return this.http
      .get(url_api, { headers: this.header, search: params })
      .map((res: any) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  getFromiCheck(url_api: string, options?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    this.header.set(
      'Authorization',
      'Basic aWNoZWNrOmlZQUYmO2NCZSNHM2F+RDojaGVjaw=='
    );
    return this.http
      .get(url_api, { headers: this.header, search: params })
      .map((res: any) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  post(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .post(environment.api_evs + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  post_qr_aps(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .post(environment.qrcode_url + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  post_qr_core_aps(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .post(environment.qrcode_url_aps + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  // postDatahub(url: string, body?: any): Observable<any> {
  //   this.header.set("Content-Type", "application/json");
  //   if (localStorage.getItem("Access-Token")) {
  //     this.header.set(
  //       "Authorization",
  //       "Bearer " + localStorage.getItem("Access-Token")
  //     );
  //   }
  //   return this.http
  //     .post(environment.apiDatahubUrl + url, body, { headers: this.header })
  //     .map((res: Response) => {
  //       return this.check(res);
  //     })
  //     .catch((error: any) => {
  //       throw this.checkErr(error);
  //     });
  // }

  postData(url: string, data?: any, file?: any): Observable<any> {
    let contentHeaders = new Headers();
    let header = contentHeaders;
    //this.header.set('Content-Type', 'multipart/form-data;');
    header.delete('Content-Type');
    if (localStorage.getItem('Access-Token')) {
      header.set('authorization', localStorage.getItem('Access-Token'));
    }
    header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    let formData = new FormData();
    if (file) {
      formData.append('file', file, file.name);
      if (data.batch_id) {
        formData.append('batch_id', data.batch_id);
      }
      let params = {};
      if (data.override) {
        params['override'] = true;
      }
      return this.http
        .post(environment.api_evs + url, formData, {
          headers: header,
          params: params,
        })
        .map((res: Response) => {
          return this.check(res);
        })
        .catch((error: any) => {
          throw this.checkErr(error);
        });
    } else {
      header.set('Content-Type', 'application/json');
      let body = {
        customer_code: data.customer_code,
        icheck_serial: data.icheck_serial,
      };
      let params = {};
      if (data.override) {
        params['override'] = true;
      }
      return this.http
        .post(environment.api_evs + url, body, {
          headers: header,
          params: params,
        })
        .map((res: Response) => {
          return this.check(res);
        })
        .catch((error: any) => {
          throw this.checkErr(error);
        });
    }
  }

  uploadFile(url: string, file?: any): Observable<any> {
    this.header.set('Content-Type', 'multipart/form-data');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.http
      .post(environment.api_evs + url, formData, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  uploadFileParams(url: string, file?: any, type?: any): Observable<any> {
    this.header.set('Content-Type', 'multipart/form-data');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    let formData = new FormData();
    formData.append('file', file, file.name);
    // formData.append("type", type);
    return this.http
      .post(environment.qrcode_url_aps + url, formData, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  postFullUrl(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .post(url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  postNoToken(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    return this.http
      .post(environment.api_evs + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  put(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .put(environment.api_evs + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) =>
        Observable.throw(this.checkErr(error) || 'Server error')
      );
  }

  put_qr_aps(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .put(environment.qrcode_url + url, body, { headers: this.header })
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  put_qr_core_aps(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .put(environment.qrcode_url_aps + url, body, { headers: this.header })
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  delete(url: string, options?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .delete(environment.api_evs + url, {
        headers: this.header,
        body: options,
      })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) =>
        Observable.throw(this.checkErr(error) || 'Server error')
      );
  }

  multiPost(url: string, data: {}): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .post(environment.api_evs + url, data, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  all(data?: {}) {
    return this.get(this.endPoint, data);
  }

  find(id, data?: {}) {
    return this.get(this.endPoint + '/' + id, data);
  }

  add(data: {}) {
    return this.post(this.endPointAdd, data);
  }

  update(id, data: {}) {
    return this.put(this.endPoint + '/' + id, data);
  }

  remove(id, data?: {}) {
    return this.delete(this.endPoint + '/' + id, data);
  }

  check(res) {
    var response = res.json() ? res.json() : true;
    let status;
    if (response.hasOwnProperty('statusCode')) {
      status = response.statusCode;
    }
    if (response.hasOwnProperty('status')) {
      status = response.status;
    }
    if (response.hasOwnProperty('code')) {
      status = response.code;
    }

    if (status == 500) {
      return response;
    }

    if (status == 200 || status == 201 || status == 1) {
      if (status == 401) {
        this.router.navigate(['/page-401']);
        throw res;
      } else {
        return response;
      }
    } else if (status == 400) {
      // throw res
      return response
    } else if (status == 401) {
      this.router.navigate(['/page-401']);
      throw res;
    } else if (status == 403) {
      localStorage.removeItem('Access-Token');
      localStorage.removeItem('Access-Token-Icheck');
      this.router.navigate(['/login']);
    } else if (status == 406) {
      this.router.navigate(['/permission/error']);
      throw res;
    } else if (status == 204) {
      return true;
    } else {
      throw res;
    }
  }

  checkErr(err) {
    var errorRes;
    try {
      errorRes = err.json();
    } catch (e) {
      console.log('Error parsing JSON from server response:', err);
      if (err.status === 401) {
        this.router.navigate(['/page-401']);
      } else if (err.status === 403) {
        localStorage.removeItem('Access-Token');
        localStorage.removeItem('Access-Token-Icheck');
        this.router.navigate(['/login']);
      }
      throw { message: 'Lỗi kết nối máy chủ hoặc hệ thống đang bảo trì. Vui lòng thử lại sau.' };
    }
    let status;
    if (errorRes.hasOwnProperty('code')) {
      return errorRes
    }
    if (errorRes.hasOwnProperty('statusCode')) {
      status = errorRes.statusCode;
    }
    if (errorRes.hasOwnProperty('status')) {
      status = errorRes.status;
    }
    if (errorRes.hasOwnProperty('data')) {
      // for api register of icheck
      if (errorRes.data && errorRes.data.hasOwnProperty('status')) {
        status = errorRes.data.status;
      }
    }

    console.log(status);


    if (status == 202) {
      throw errorRes;
    }
    if (status == 200 || status == 201) {
      if (status == 401) {
        throw errorRes;
      } else if (errorRes.data) {
        return errorRes.data;
      } else {
        return true;
      }
    } else if (status == 400 || status === 101 || status == 8001 || status === 8002) {
      throw errorRes;
    } else if (status === 401) {
      if (errorRes.data) {
        if (errorRes.data.user_status == 2) {
          localStorage.setItem('expires_at', '0');
          this.router.navigate(['/evs/dashboard']);
        } else {
          this.router.navigate(['/page-401']);
        }
      } else {
        this.router.navigate(['/page-401']);
      }
      throw errorRes;
    } else if (status == 403) {
      localStorage.removeItem('Access-Token');
      localStorage.removeItem('Access-Token-Icheck');
      this.router.navigate(['/login']);
    } else if (status == 404) {
      throw { message: 'Không có dữ liệu.' };
    } else if (status == 406) {
      this.router.navigate(['/permission/error']);
      throw errorRes;
    } else if (status == 204) {
      return true;
    } else {
      let mess_xxx = '';
      if (errorRes.data) {
        mess_xxx = errorRes.data.messae
          ? errorRes.data.messae
          : 'Có lỗi xảy trong quá trình lấy thông tin. Vui lòng thử lại sau.';
      } else {
        mess_xxx = errorRes.message
          ? errorRes.message
          : 'Có lỗi xảy trong quá trình lấy thông tin. Vui lòng thử lại sau.';
      }
      throw { message: mess_xxx };
    }
  }

  getexcel(url: string, name: string = '') {
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
      this.header.append('Content-Type', 'application/json');
      this.header.append('responseType', 'blob');
      this.header.append('Accept', 'application/octet-stream');
    }
    let name2 = name.replace(' ', '-');

    this.http
      .get(environment.api_evs + url, {
        headers: this.header,
        responseType: ResponseContentType.ArrayBuffer,
      })
      .map((res: any) => {
        return res;
      })
      .subscribe(
        (data) => {
          console.log(typeof data._body);
          let blob = new Blob([data._body], {
            type: 'application/zip',
          });
          FileSaver.saveAs(blob, 'Icheck-' + name2 + '.zip');
        },
        (err) => {
          console.error(err);
        }
      );
  }

  public loginFB(token_icheck) {
    let body = {
      icheck_token: token_icheck,
      ttl: 31556926,
    };
    return this.http
      .post(environment.api_evs + '/login/token', body)
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
    // this.http.post(environment.api_evs + '/login/token', body).subscribe(
    //     res => {
    //         let body = JSON.parse(res['_body']);
    //         console.log('loginFB: ', body);
    //         if (body.status == 200) {
    //             // localStorage.setItem('Access-Token', body.data.token);// save token to local
    //             return body.data;
    //         } else {
    //             throw res;
    //         }
    //     },
    //     error => {
    //         throw error;
    //     });
  }

  registerIcheck(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    this.header.set('Authorization', '');

    return this.http
      .post(environment.url_icheck + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  confirmOTPIcheck(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    this.header.set('Authorization', '');

    return this.http
      .post(environment.url_icheck + url, body, { headers: this.header })
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  // getResendOTP(url: string, param?: any): Observable<any> {
  //   this.header.set('Content-Type', 'application/json');
  //   return this.http
  //     .get(environment.url_icheck + url, {headers: this.header, search: param})
  //     .map((res: any) => {
  //       return this.check(res);
  //     })
  //     .catch((error: any) => {
  //       throw this.checkErr(error);
  //     });
  // }

  getResendOTP(url: string, options?: any): Observable<any> {
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('authorization', localStorage.getItem('Access-Token'));
    }
    this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return this.http
      .get(environment.url_icheck + url, { headers: this.header, search: params })
      .map((res: any) => {
        // console.log("ewsss", res);
        return this.check(res);
      })
      .catch((error: any) => {
        // console.log("errrorrrrrrrrr", error)
        throw this.checkErr(error);
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/common/services/ApiEvs.service.ts